import React, {Component} from "react";
import {Checkbox, Form, FormInstance, Input} from "antd";
import User, {UserFormData} from "../../types/User";
import {roleLabel} from "./UserRole";

interface UserFormFormState {
    isLoading: boolean
}

interface UserFormProps {
    onUserFormData: (formData: UserFormData) => void
    roles: string[]
    user?: User
}

export default class UserForm extends Component<UserFormProps, UserFormFormState> {
    formRef = React.createRef<FormInstance>();

    defaultRole = "ROLE_USER"

    onFinish = (values: any) => {
        const {username, password, roles} = values
        this.props.onUserFormData({username, password, roles})
    };

    componentDidMount() {
        if (this.props.user) {
            const {username, roles} = this.props.user;
            this.formRef.current?.setFieldsValue({username, roles})
        } else {
            this.formRef.current?.setFieldsValue({roles: [this.defaultRole]})
        }
    }

    render() {
        return (
            <Form layout="vertical" requiredMark={false} ref={this.formRef} name="team-member" onFinish={this.onFinish}>
                <Form.Item name="username" label="Username"
                           extra="5 to 25 characters"
                           rules={[{required: true, message: 'Enter a username'}, {
                               min: 5,
                               message: "Use at least 5 characters"
                           }, {max: 25, message: "Use 25 characters or fewer"}]}>
                    <Input autoComplete="off"/>
                </Form.Item>
                <Form.Item name="password" label="Password"
                           extra={this.props.user ? "Leave empty to keep their current password" : "At least 8 characters"}
                           rules={[{required: !this.props.user, message: 'Set a password'}, {
                               min: 8,
                               message: "Use at least 8 characters"
                           }, {max: 128, message: "Use 128 characters or fewer"}]}>
                    <Input.Password autoComplete="new-password"/>
                </Form.Item>
                <Form.Item name="roles" label="Roles" extra="Every member keeps the User role.">
                    <Checkbox.Group>
                        {this.props.roles.map(role => <Checkbox key={role} value={role}
                                                                disabled={role === this.defaultRole}>{roleLabel(role)}</Checkbox>
                        )}
                    </Checkbox.Group>
                </Form.Item>

            </Form>
        );
    }
}
